/**
 * 排行榜单左侧
 * 2019-5-14
 * Bai.Zhiming
 */
"use strict";
angular.module("rankingListLeftModule", []).
directive("rankingListLeft", ["$state", "$timeout", function($state, $timeout) {
    return {
        restrict: "E",
        replace: true,
        templateUrl: "./planningCenter/rankingList/left/left_tpl.html",
        scope: {
            selected: "="
        },
        link: function(scope, $elem, $attrs) {
            initStatus();
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                    expanded: false,
                    expandedLeve2: ""
                };
                autoLocation()
            }

            function autoLocation() {
                scope.$watch("selected", (newV, oldV) => {
                    if (newV === "rankinglist") {
                        scope.status.expanded = true;
                        let routerName = $state.current.name;
                        let routerArray = routerName.split(".");
                        if ($state.current.name != "front.plan.rankinglist") {
                            scope.status.expandedLeve2 = routerArray[3];
                            scope.$root.narrowNavigation = true;
                        }
                    } else {
                        scope.status.expandedLeve2 = "";
                    }
                });
            }
            /**
             * [selectLeve2 description] 选中二级
             * @param  {[type]} routerNamePart [description] 路由名称
             * @return {[type]}            [description]
             */
            scope.selectLeve2 = function(routerNamePart) {
                scope.status.expandedLeve2 = routerNamePart;
                $state.go("front.plan.rankinglist." + routerNamePart, "", { reload: "front.plan.rankinglist." + routerNamePart });
                scope.$root.narrowNavigation = true;
                if (scope.selected !== "rankinglist") {
                    $timeout(() => {
                        scope.selected = "rankinglist";
                    }, 500);
                }
            };
        }
    };
}]);